import { virtualBackgroundItemSchema } from 'features/virtual-backgrounds/schemas';
import {
  PersistedVirtualBackgroundEntry,
  VirtualBackgroundItem,
} from 'features/virtual-backgrounds/types';
import { logger } from 'utils/logger';

export const mapPersistedVirtualBackgrounds = (
  entries: PersistedVirtualBackgroundEntry[]
): VirtualBackgroundItem[] => {
  const items: VirtualBackgroundItem[] = [];

  for (const entry of entries) {
    const parsed = virtualBackgroundItemSchema.safeParse({
      id: entry.id,
      type: 'image',
      value: entry.url,
      thumbnail: entry.thumbnailUrl ?? undefined,
      label: entry.name,
      isCustom: true,
      persisted: true,
    });

    if (parsed.success) {
      items.push(parsed.data);
    } else {
      logger
        .remote()
        .error(`Skipping invalid persisted virtual background id=${entry.id}`, parsed.error);
    }
  }

  return items;
};
